import BasePage from '@/found/components/table_page';
import detailForm from './form/details.vue';

export default {
  name: 'chanel_cost_customer',
  extends: BasePage,
  data() {
    return {

    };
  },
  components: {
    detailForm,
  },
  created() {
    this.getConfigList('customer_channel_fee_pool_list');
  },
  methods: {

    modalClick({ val, row }) {
      if (val.code === 'detail') {
        this.formName = 'detailForm';
        this.propsObjInData.row = { feePoolCode: row.feePoolCode };
        this.modalConfig.title = '明细';
        this.openFull();
      }
    },
  },
};
